import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { DURATION_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';

export const config = {
    id: ActionType.ANIM_DURATION,
    icon: DURATION_ICON,
    content: i18n.t('持续时间'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: `${config.id}-drop-content`,
        style: {
            width: 'auto',
            overflow: 'hidden',
            zoom: 1,
            padding: 0,
            height: 'auto',
            position: 'relative',
            margin: '-8px 0',
        },
    },
];
